import { render, staticRenderFns } from "./UserBuilder.vue?vue&type=template&id=30274938&scoped=true"
import script from "./UserBuilder.vue?vue&type=script&lang=js"
export * from "./UserBuilder.vue?vue&type=script&lang=js"
import style0 from "./UserBuilder.vue?vue&type=style&index=0&id=30274938&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30274938",
  null
  
)

export default component.exports